var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileDef(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2112",
    "data-name": "Rectangle 2112",
    width: 32,
    height: 32,
    rx: 16
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(4.707 6.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M53.5,55,42.742,62.967l.114,1.887v2.4L39,70.148l3.856,5.068h8.436l-.279-7.476a2.989,2.989,0,0,0,1.8-.837,3.186,3.186,0,0,0,.962-2.293V56.325A3.681,3.681,0,0,0,53.5,55Z",
    transform: "translate(-35.848 -49.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M20.475,159h9.019s6.787,2.625,6.787,5.716H16.39c0-1.821,2.091-4.159,3.292-5.189A2.251,2.251,0,0,1,20.475,159Z",
    transform: "translate(-16.39 -139.242)",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M66.382,62.5v3a3.139,3.139,0,0,1-1.255,2.851s-1.033-3.837-2.649-1.952c-.837.976.558,2.616.558,2.788,0,1.952-2.091,2.928-3.269,2.928H56.505s-.022-.685-.022-1.055v-.073a7.35,7.35,0,0,1-1.623-1.272,16.01,16.01,0,0,0,1.623-.078c2.231-.223.529-2.2,1.389-2.907l1.12-2.46c.558-.464,2.813,2.817,3.16,2.46l.047-.047Z",
    transform: "translate(-49.496 -56.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M118.622,19.685a2.155,2.155,0,0,1-.633,1.534l-.976.976-.738.738a7.25,7.25,0,0,0-.646-1.255l-.011-.018a7.374,7.374,0,0,0-1.265-1.479c-.131-.12-.268-.234-.409-.343a7.425,7.425,0,0,0-1.865-1.058c.252-.178.5-.344.745-.494a8.428,8.428,0,0,1,.848-.456s2.579-1.421,4.316.328A2.155,2.155,0,0,1,118.622,19.685Z",
    transform: "translate(-98.739 -17.285)",
    fill: "#355dad",
    opacity: 0.997
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M54.272,29.141l-4.839,4.839-.047.047-1,1-.293.294h-.007a7.72,7.72,0,0,1-4.371,1.614,16.009,16.009,0,0,1-1.623.078A7.385,7.385,0,0,1,47.411,24.5a7.516,7.516,0,0,1,.976.064,7.356,7.356,0,0,1,3.555,1.488c.139.109.279.223.409.343a7.374,7.374,0,0,1,1.265,1.479l.011.018A7.25,7.25,0,0,1,54.272,29.141Z",
    transform: "translate(-36.73 -23.494)",
    fill: "#039"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDef);
export default __webpack_public_path__ + "static/media/profileDef.c85411fc702a31b9fb2b6872605df64a.svg";
export { ForwardRef as ReactComponent };